
export default {
  customers: {
    _tag: 'CSidebarNavItem',
    name: 'customers',
    phrase: 'nav-customers',
    to: '/customers',
    icon: 'fa-regular fa-user',
   roles: ['Admin','Sub Admin'],
    order:7,
  },
}
